import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    boxSizing: "border-box",
    gap: "16px",
    borderBottom: "none",
  },
  paper: {
    display: "flex",
    justifyContent: "space-between",
    background: "#F9FAFA",
    boxShadow: "none",
    padding: theme.spacing(3, 2),
  },
  label: {
    color: "#5F6164",
    fontSize: 14,
    marginBottom: 4,
    textTransform: "capitalize",
  },
  leftBox: {
    display: "flex",
    gap: 8,
    alignItems: "flex-end",
  },
  rightBox: {
    display: "flex",
    gap: 8,
    justifyContent: "space-between",
    alignItems: "flex-end",
    flex: 1,
  },
  contentBox: {
    position: "relative",
    display: "flex",
    flexDirection: "row",
    margin: theme.spacing(0, 2),
    maxHeight: "calc(100vh - 210px)",
    overflow: "hidden",
  },
  tableContainer: {
    scrollbarWidth: "none",
    display: "inline-block",
    width: "auto",
    maxWidth: "none",
    overflow: "auto",
    position: "relative",
    boxShadow: "none",
    borderRight: "1px solid #BEBFC0",
    maxHeight: "calc(100vh - 218px)",
    boxSizing: "border-box",
  },
  tableContainer2: {
    display: "inline-block",
    flex: 1,
    overflow: "auto",
    position: "relative",
    boxShadow: "none",
    border: "none",
    maxHeight: "calc(100vh - 210px)",
    boxSizing: "border-box",
  },
  tableFooter: {
    position: "sticky",
    bottom: 0,
    zIndex: 2,
    background: "#F9FAFA",
  },
  tableFooterCell: {
    background: "#F9FAFA",
    borderTop: "1px solid #BEBFC0",
    borderBottom: "1px solid #BEBFC0",
    height: 64,
    padding: "14px",
    boxSizing: "border-box",
  },
  footerBox: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: 4,
  },
  footerIcon: {
    fontSize: 16,
    color: "#5F6164",
  },
  fixedHeightOne: {
    height: 94
  },
  fixedHeight: {
    height: 104
  },
  fixedWidth: {
    width: 120,
    maxWidth: 120
  },
  tableHeadCell: {
    padding: 0,
    background: "#F9FAFA",
    borderBottom: "1px solid #BEBFC0",
  },
  tableHeadCheckCell: {
    background: "#F9FAFA",
    borderBottom: "1px solid #BEBFC0",
  },
  tableHeadDateCell: {
    minWidth: 200,
    padding: 0,
    background: "#F9FAFA",
    borderBottom: "1px solid #BEBFC0",
  },
  dateHeadContent: {
    display: "flex",
    flexDirection: "column",
  },
  dateHeadDay: {
    padding: "12px 16px",
    textTransform: "uppercase",
  },
  dateHeadDayLabel: {
    fontWeight: 600,
    textWrap: "nowrap",
  },
  dateHeadFooter: {
    padding: "12px 16px",
    borderTop: "#bebfc0 1px solid",
  },
  dateHeadStats: {
    display: "flex",
    alignItems: "center",
    gap: 16,
  },
  dateHeadStat: {
    display: "flex",
    alignItems: "center",
    gap: 6,
  },
  dateHeadStatIcon: {
    "&&": {
      fontSize: 20,
      width: 20,
      height: 20,
    },
  },
  dateHeadStatText: {
    fontSize: 16,
    fontWeight: 500,
  },
  tableCell: {
    background: "#F9FAFA",
    textWrap: "nowrap",
    height: 118,
    padding: 8,
    boxSizing: "border-box",
    borderBottom: "1px solid #BEBFC0",
  },
  tableBorderLeft: {
    borderLeft: "1px solid #BEBFC0",
  },
  tableBorderRight: {
    borderRight: "1px solid #BEBFC0",
  },
  tableCellContent: {
    padding: "14px",
  },
  activeRow: {
    background: "#e0e5fa",
  },
  unpublishedIcon: {
    position: "absolute",
    top: 3,
    right: 3,
  },
  tenuredCell: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    justifyContent: "flex-end",
  },
  textWrap: {
    textWrap: "nowrap",
  },
  tenuredIcon: {
    color: "#1B7E43",
  },
  blackColor: {
    color: "#0E1011",
  },
  whiteColor: {
    color: "white",
  },
  greenColor: {
    color: "#145E32",
  },
  grayColor: {
    color: "#5F6164",
  },
  standardTheme: {
    background: "#0129FA",
  },
  abscentTheme: {
    background: "#881414",
  },
  rescueTheme: {
    background: "#1B7E43",
  },
  standbyTheme: {
    background: "#A75700",
  },
  trainingTheme: {
    background: "#FFBA70",
  },
  qualityTheme: {
    background: "#FF4741",
  },
  specialTheme: {
    background: "#67D3F3",
  },
  availableTheme: {
    background: "#A8DABC",
  },
  unavailableTheme: {
    background: "#EAECEC",
  },
  mycuCancelledTheme: {
    background: "#828487",
  },
  clientCancelledTheme: {
    background: "#3E4042",
  },
  flexTheme: {
    background: "#7A90FF",
  },
  dispatcherTheme: {
    background: "#00B4F9",
  },
  supervisorTheme: {
    background: "#7E40F7",
  },
  fleetCoordinatorTheme: {
    background: "#57E7B0",
  },
  leadDriverTheme: {
    background: "#FFF140",
  },
  helperTheme: {
    background: "#011DA7",
  },
  rejectedTheme: {
    background: "#C42020",
  },
  supportDispatcherTheme: {
    background: "#54A2B8",
  },
  performanceCoordinator: {
    background: "#00AE87",
  },
  scheduleBox: {
    boxSizing: "border-box",
    position: "relative",
    minHeight: "100%",
    borderRadius: 8,
    padding: 8,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:hover": {
      opacity: 0.7,
    },
  },
  consecutiveBorder: {
    border: "5px solid #C42020",
  },
  selectCheckbox: {
    "&.MuiCheckbox-colorSecondary.Mui-checked": {
      color: "#0129FA",
    },
    fill: "#5F6164",
  },
  emptyScheduleBox: {
    boxSizing: "border-box",
    minHeight: "100%",
    borderRadius: 8,
    padding: 8,
    border: "1px dashed #828487",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:hover": {
      background: "#0000000a",
    },
  },
  selectedBorder: {
    border: "5px solid #02020256",
  },
  scheduleBoxTop: {
    display: "flex",
    justifyContent: "flex-end",
  },
  cellContent: {
    padding: "0 2px",
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
  },
  scheduleHours: {
    opacity: 0.8,
    display: "flex",
    alignItems: "center",
    gap: 4,
  },
  scheduleHoursText: {
    fontSize: "12px !important",
  },
  scheduleHoursIcon: {
    fontSize: 16,
  },
  addScheduleIcon: {
    color: "#5F6164",
  },
  firstCellBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  driverBox: {
    flex: 2,
  },
  errorColor: {
    color: "#C42020",
    fill: "#C42020",
    "&.MuiSvgIcon-root": {
      color: "#C42020",
      fill: "#C42020"
    }
  },
  "@media (max-width: 840px)": {
    paper: {
      flexDirection: "column",
      gap: 8,
    },
    rightBox: {
      flexDirection: "column",
      justifyContent: "flex-end",
    },
  }
}));
